import { render, staticRenderFns } from "./LoaderScoped.vue?vue&type=template&id=4d3636ec&scoped=true&"
import script from "./LoaderScoped.vue?vue&type=script&lang=js&"
export * from "./LoaderScoped.vue?vue&type=script&lang=js&"
import style0 from "./LoaderScoped.vue?vue&type=style&index=0&id=4d3636ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3636ec",
  null
  
)

export default component.exports